<template>
  <article class="card-custom avo">
    <div class="avo-title">{{ nombre }} vs ONEST</div>
    <div class="avo-sub">
      Score, NPS, CES y CSAT de la cuenta contra el promedio global del mismo
      periodo
    </div>

    <div class="avo-rows">
      <div v-for="m in data" :key="m.metrica" class="avo-row">
        <span class="avo-metrica">{{ m.metrica }}</span>

        <div class="avo-track">
          <!-- Ambas barras se escalan contra el mayor de las dos, para que la
               comparación relativa sea legible sin importar la unidad. -->
          <div class="avo-bar cuenta" :style="{ width: ancho(m, m.cuenta) }">
            <span v-if="m.cuenta != null" class="avo-val">{{ fmt(m.cuenta) }}</span>
          </div>
          <div class="avo-bar onest" :style="{ width: ancho(m, m.onest) }">
            <span v-if="m.onest != null" class="avo-val">{{ fmt(m.onest) }}</span>
          </div>
        </div>

        <span
          v-if="delta(m) != null"
          class="avo-delta"
          :class="delta(m) >= 0 ? 'up' : 'down'"
        >
          {{ delta(m) >= 0 ? "+" : "" }}{{ fmt(delta(m)) }}
        </span>
        <span v-else class="avo-delta avo-nd">—</span>
      </div>
    </div>

    <div class="avo-legend">
      <span><i class="lg lg-cuenta"></i> {{ nombre }}</span>
      <span><i class="lg lg-onest"></i> Promedio ONEST</span>
    </div>
  </article>
</template>

<script>
export default {
  name: "AccountVsOnestChart",

  props: {
    // [{ metrica, cuenta, onest }]
    data: { type: Array, default: () => [] },
    nombre: { type: String, default: "Cuenta" },
  },

  methods: {
    fmt(v) {
      return v == null ? "—" : Number(v).toFixed(1);
    },

    delta(m) {
      if (m.cuenta == null || m.onest == null) return null;
      return Math.round((m.cuenta - m.onest) * 10) / 10;
    },

    // Escala relativa por métrica: NPS (-100..100) y CES (0..10) no comparten
    // unidad, así que cada fila se normaliza contra su propio máximo.
    ancho(m, valor) {
      if (valor == null) return "0%";
      const max = Math.max(Math.abs(m.cuenta ?? 0), Math.abs(m.onest ?? 0)) || 1;
      return Math.max(2, (Math.abs(valor) / max) * 100) + "%";
    },
  },
};
</script>

<style scoped>
.avo-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--heading);
}

.avo-sub {
  font-size: 12px;
  color: var(--txt-dim);
  margin-bottom: 16px;
}

.avo-rows {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.avo-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avo-metrica {
  width: 64px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--txt-dim);
}

.avo-track {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.avo-bar {
  height: 17px;
  border-radius: 5px;
  min-width: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 6px;
  transition: width 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.avo-bar.cuenta {
  background: var(--primary);
}
.avo-bar.onest {
  background: var(--secondary);
}

.avo-val {
  font-size: 10.5px;
  font-weight: 700;
  color: var(--on-accent);
  font-variant-numeric: tabular-nums;
}

.avo-delta {
  width: 54px;
  text-align: right;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.avo-delta.up {
  color: var(--verde);
}
.avo-delta.down {
  color: var(--rojo);
}
.avo-nd {
  color: var(--txt-faint);
}

.avo-legend {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 16px;
  font-size: 12px;
  color: var(--txt-dim);
}
.avo-legend .lg {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 5px;
}
.lg-cuenta {
  background: var(--primary);
}
.lg-onest {
  background: var(--secondary);
}
</style>
